module.exports = __webpack_public_path__ + "0d6db1f1d8fc560a976057fafbf5bd96.svg";